// extracted by mini-css-extract-plugin
export default {"header":"Zlf8tDeTFmYyRw3W414g","nnaIdSection":"eYTVAO8R5nVQ1heZrMgS"};